import ReactPixel from 'react-facebook-pixel';

const options = {
  autoConfig: true,
  debug: false,
};

export const initFacebookPixel = () => {
  ReactPixel.init('ТВОЙ_PIXEL_ID', undefined, options);
  ReactPixel.pageView(); // Отправить событие "PageView"
};

export const trackPixelEvent = (eventName, data = {}) => {
    if (window.fbq) {
        window.fbq("track", eventName, data);
    }
};
